import React, { } from 'react'
import { Redirect } from 'react-router-dom'
import Common from '../Utility/Common'
function Unprotected(props) {
    //const common = new Common();
    var path = window.location.pathname
    return <div> {Common.UserId() && path != '/adminlogin' ? <Redirect to="/home"></Redirect> : <props.cmp />} </div>
}
export default Unprotected;